/*
 * @Author: 菲鸽
 * @Date: 2024-03-28 19:13:55
 * @Last Modified by: 菲鸽
 * @Last Modified time: 2024-03-28 19:24:55
 */
export const platform = __UNI_PLATFORM__
export const isH5 = __UNI_PLATFORM__ === 'h5'
export const isApp = __UNI_PLATFORM__ === 'app'
export const isMp = __UNI_PLATFORM__.startsWith('mp-')

/**
 * 判断是否在微信浏览器中
 */
export const isWeChatBrowser = () => {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent.toLowerCase()
  return /micromessenger/.test(ua)
}

const PLATFORM = {
  platform,
  isH5,
  isApp,
  isMp,
  isWeChatBrowser,
}
export default PLATFORM
